const TetherCnt = {
  symbol: "TRX",
  name: "tron",
  meta: {
    title: "Buy tron | Sell tron | tron prices and charts",
    description:
      "Tron digital currency (TRX) is one of the most popular cryptocurrencies on the market. Kevin Nick Market provides the Theron sales and purchases with the best price, the safest platform and the lowest commission.",
    keywords: "Tron, buy tron, sell tron, tron price",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه ترون بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید ترون  کنید. قیمت ترون در کوین‌نیک مارکت توسط خود شما تعیین می‌شود.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول ترون کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " برای ترون ده‌ها کیف پول وجود دارد. بنابراین اگر یک سرمایه‌گذار ترون باشید، پیداکردن کیف پول کار سختی برای شما نخواهد بود. در ادامه چند مورد از بهترین کیف پول‌های ترون را معرفی کرده‌ایم: کیف پول Trust Walletبرای موبایل؛ کیف پول Exodus برای دسکتاپ و موبایل؛ کیف پول سخت‌افزاری Ledger؛ کیف پول سخت‌افزاری  Trezor؛ کیف پول نرم‌افزاری Metamask.",
        },
      },
      {
        "@type": "Question",
        name: " آیا در کوین‌نیک مارکت می‌توان ترون را نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهایتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا ترون ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " اگرچه ترون در حال حاضر از قیمت پایینی برخوردار است، اما بسیاری از حرفه‌ای‌ها معتقدند ترون گزینه خوبی برای سرمایه‌گذاری بلندمدت است. از آنجایی که کاربرد اپلیکیشن‌های غیرمتمرکز رو به افزایش است و از محبوبیت روزافزونی برخوردارند، پیش بینی می شود شبکه ترون در آینده نقش مهمی در این زمینه ایفا خواهد کرد.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy tron",
      answer:
        "In coinnik Market trading platform, you can buy thrones with Shetab member bank card and the lowest fee. The price of Theron in Quinnic Market is determined by you.",
      id: "toggler1",
    },
    {
      question: "What is the best tron wallet?",
      answer: "Tron_wallet_description",
      id: "toggler2",
    },
    {
      question: "Can I keep a tron at coinnik Market?",
      answer: "Keep_tron_description",
      id: "toggler3",
    },
    {
      question: "Is tron worth the investment?",
      answer: "Tron_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about tron",
        subTitle: "What is tron?",
        content: "Tron_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of tron",
        content: "Tron_history_description",
        btnTitle: "Buy and sell tron",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle: "Buy and sell tron without intermediaries in coinnik Market",
        subTitle: "Buy tron",
        content: "Buy_tron_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sell tron",
        content: "Sell_tron_description",
        btnTitle: "Buy and sell tron",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest tron analysis on the blog",
  informationTitle: "tron market statistics and information",
};

export default TetherCnt;
